<template>
    <div class="login apppadding">
<!--        <div class="logincontainer" style="height:auto;">-->
<!--            <div>-->
<!--                <img :src="logo" />-->

<!--                <div>-->
<!--                    当前应用需要登录方可使用.-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="page-container-padding" style="height:auto;">-->
<!--            <Button type="warning" :loading="loading" loading-text="授权登录中" size="large" round @click="login"> 授权并登录 </Button>-->
<!--        </div>-->
      <loading type="spinner" color="#1989fa" >加载中...</loading>
    </div>
</template>

<script>
    import {jinLogin, userinfolist, info,} from '@/libs/api.js'
    import { getLastRouter, goBack, setStorage, islogin} from '@/libs/utils'
    import { Button,Toast,Loading } from 'vant'
    export default {
        name: 'matchdetail',
        components: {
            Button,Loading
        },
        data() {
            return {
                logo: '',
                loading: false
            }
        },
        methods: {
        },
        mounted() {
            this.$nextTick(() => {
                info().then((res)=>{
                    if(res.status==200)
                    {
                        this.logo = res.data.info.logo
                        //缓存
                        setStorage('enterpriseinfo',res.data,true);
                    }else{
                        this.logo = "@/images/logo@3x.png"
                    }
                })
                if(!islogin()){
                   if(!!this.$route.query.code){
                        this.loading = true
                        Toast.loading({
                            duration: 0,
                            mask: true,
                            message: '登录中...'
                        });
                        jinLogin({code:this.$route.query.code}).then((res)=>{
                            if(res.status!=200){
                                  this.$router.push({
                                      query:{}
                                  })
                            }else{
                                //跳转到 登录前的页面
                                Toast.clear();
                                let to = getLastRouter()
                                let urid = res.data.urid
                                let token = res.data.token
                                userinfolist({urid:res.data.urid,token:res.data.token}).then((res)=>{
                                    if(res.status == 200){
                                        let rawData = res.data
                                        rawData.urid = urid
                                        rawData.token = token
                                        rawData.logintime = new Date().getTime()
                                        setStorage('userInfo',rawData, true)
                                        this.$router.replace({name:to.name,params:to.params})
                                    }
                                })

                            }

                        })


                    }else{
                        window.location.href = 'https://api.eshimin.com/api/oauth/authorize?client_id=8O7i8VUgyj&response_type=code&redirect_uri=https://changning.movecloud.cn/'
                    }
                }else{
                    window.location.href = 'https://api.eshimin.com/api/oauth/authorize?client_id=8O7i8VUgyj&response_type=code&redirect_uri=https://changning.movecloud.cn/'
                }


            })

        }
    }
</script>

<style scoped lang="less">
    .login{
        .logincontainer{
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding: 100px 0;
            box-sizing: border-box;
        }

        .logincontainer div{
            display:flex;
            flex-direction:column;
            align-items:center;
        }
        /*.container view>view:nth-child(2)*/
        /*{*/
        /*margin:20rpx auto;*/
        /*font-size:40rpx;*/
        /*}*/
        .logincontainer div img:nth-child(1)
        {
            width:120px;
            /*height:343rpx;*/
            /*border-radius:50%;*/
        }

        .logincontainer div:nth-child(1) img:nth-child(2)
        {
            width:320px;
            height:91px;
        }
        .logincontainer div div:last-child{
            height:100px;
            width:350px;
            font-size:14px;
            background-image:url('https://moveclub-file.oss-cn-hangzhou.aliyuncs.com/icon/logintips.png');
            background-size:100% 100%;
            padding:12px;
            padding-top:22.5px;
            box-sizing:border-box;
            display:flex;
            align-items:center;
            justify-content:center;
        }
        .footer{
            box-shadow:none;
        }
    }

</style>

